export default {
  dodgerBlue: "#1E84E2",
  layoutColor: "#7d7d7d",
  textOrderNumber: "#000000",
  errorContainerBackground: "#ffbaba",
  errorContainerBorder: "#ff0000",
  errorText: "#d8000c",
  white: "#ffffff",
};
